import { URI } from '@/config/config';

export default async ({ rootState }, payload) => {
  const token = rootState['DATA-ACCESS'].tokenAuth;

  const opts = {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      'user-token': rootState['DATA-ACCESS'].userToken,
      Authorization: `Bearer ${token}`,
    },
    body: JSON.stringify(payload),
  };
  const path = new URL(`${URI}user/update-user-data`);

  const response = await fetch(path, opts);
  const jsonResult = await response.json();
  if (response.status >= 400) {
    return Promise.reject(jsonResult.error);
  }

  return jsonResult;
};
